import { ArrowRight, ShoppingBag, Star, Shield, Zap } from "lucide-react";
import { Wrapper } from "./Styles";

const SHOP_URL = "https://shop.hanypay.co/";

const features = [
  {
    icon: ShoppingBag,
    title: "Browse products",
    description: "Explore a wide range of products from verified sellers.",
  },
  {
    icon: Shield,
    title: "Secure payments",
    description: "Pay seamlessly with your Hanypay wallet.",
  },
  {
    icon: Zap,
    title: "Fast delivery",
    description: "Get your orders delivered quickly and reliably.",
  },
];

const Marketplace = () => {
  return (
    <Wrapper>
      <div className="flex min-h-[70vh] flex-col items-center justify-center px-4">
        <div className="w-full max-w-2xl text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-rose-500 to-orange-400 shadow-lg">
            <ShoppingBag className="h-8 w-8 text-white" />
          </div>

          <h1 className="text-3xl font-black tracking-tight text-slate-900 md:text-4xl">
            Hanymarket
          </h1>
          <p className="mx-auto mt-3 max-w-md text-base text-slate-500">
            Shop, sell, and pay — all powered by your Hanypay wallet.
          </p>

          <a
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800"
          >
            Visit Hanymarket
            <ArrowRight className="h-4 w-4" />
          </a>

          <div className="mt-12 grid gap-4 sm:grid-cols-3">
            {features.map(({ icon: Icon, title, description }) => (
              <div
                key={title}
                className="rounded-2xl border border-slate-100 bg-white p-5 text-left shadow-sm"
              >
                <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-rose-50 text-rose-500">
                  <Icon className="h-5 w-5" />
                </div>
                <p className="text-sm font-semibold text-slate-900">{title}</p>
                <p className="mt-1 text-xs text-slate-500">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Marketplace;
